/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_Labeled_FieldInputs */

const cs_builder_block_labeled_field = /** @type {(inputs: Builder_Block_Labeled_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole se štítkem`)
};

const en_builder_block_labeled_field = /** @type {(inputs: Builder_Block_Labeled_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labeled field`)
};

/**
* | output |
* | --- |
* | "Labeled field" |
*
* @param {Builder_Block_Labeled_FieldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_labeled_field = /** @type {((inputs?: Builder_Block_Labeled_FieldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_Labeled_FieldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_labeled_field(inputs)
	return cs_builder_block_labeled_field(inputs)
});